// extracted by mini-css-extract-plugin
export default {"BoA-individual-pages":"About_BoA-individual-pages__qNOd+","fade":"About_fade__S5Lvg","BoA-About2-pages":"About_BoA-About2-pages__mSp6X"};